import "./loader.scss";

export default function Loader() {
  return (
      <div className="loader">
        <div className="loader-logo" />
      </div>
  );
}
